export const SUGGESTER_STORAGE_KEY = 'ai-suggestions';
